<template>
  <section class="section is-paddingless">
    <div class="container is-fluid is-paddingless">
      <header-component />

      <div class="columns is-marginless">
        <div class="column is-2 side-navigation is-hidden-mobile">
          <side-menu />
        </div>
        <div class="column is-10 is-paddingless">
          <slot />
        </div>
      </div>
    </div>

    <mobile-menu />
  </section>
</template>

<script>
import SideMenu from '../components/SideMenu.vue';
import MobileMenu from '../components/MobileMenu.vue';
import HeaderComponent from '../components/Header.vue';

export default {
  name: 'Dashboard',
  components: {
    HeaderComponent,
    MobileMenu,
    SideMenu,
  },
};
</script>

<style scoped>
 .side-navigation {
   border-right: 1px solid black;
 }
</style>
